module.exports = __webpack_public_path__ + "bin/9dd8dacf06e237c5fa4977187e648b0f.jpg";